import React from 'react'

import { connect } from 'react-redux'
import { setTrackCached } from '../../actions'

import { slugify } from '../../utils'

import * as Cloud from '../visuals/Cloud'

const mapStateToProps = (state, ownProps) => ({

})

const mapDispatchToProps = (dispatch) => ({
  setTrackCached: (track) => dispatch(setTrackCached(track))
})

class DownloadTrackButton extends React.Component {

  // Request 1GB by default
  requestAccess = () => {

    if ('webkitPersistentStorage' in navigator) {
      var requestBytes = Math.pow(1024, 3)
      navigator.webkitPersistentStorage.requestQuota(requestBytes, (grantedBytes) => {

      })
    }

  }

  cache = async () => {

    this.requestAccess()

    const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/tracks/${slugify(this.props.track.book)}/${this.props.track.chapter}.mp3`, {
      method: 'GET',
      headers: {
        'x-should-cache': true
      }
    })

    this.props.setTrackCached(this.props.track)
  }


  render () {
    if ('caches' in window && 'serviceWorker' in navigator)
      return (this.props.track.cached) ? <Cloud.Downloaded /> : <Cloud.Download onClick={this.cache} />
    else
      return null
  }
}


DownloadTrackButton = connect(mapStateToProps, mapDispatchToProps)(DownloadTrackButton)

export default DownloadTrackButton



// WEBPACK FOOTER //
// ./src/components/Main/DownloadTrackButton.js